/* eslint-disable react/jsx-curly-newline */
/* eslint-disable react/jsx-one-expression-per-line */
import React, { useContext, useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { useHistory, useParams } from 'react-router-dom';
import {
  TableBody,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@material-ui/core';
import { useRecoilState, useSetRecoilState } from 'recoil';
import LoadingOverlay from 'react-loading-overlay';
import AuthenticatedContext from '../../context/AuthenticatedContext';
import {
  backPageFlg,
  pageTitle,
  partsListPageInfo,
} from '../../context/PageRecoil';
import { pathnames } from '../../api';
import { requestDeviceDetail } from '../../api/device';
import useStyles, { headerWidth } from '../../css/style';
import Paging from '../paging';
import { OneEquipment } from '../../models/data/Equipment';
import { requestOneEquipment } from '../../api/equipment';
import { routeName } from '../../App';
import Parts from '../../models/data/Parts';
import requestPartsList, { requestCountParts } from '../../api/parts';
import { DeviceDetail } from '../../models/data/Device';
import DataDisp from './datadisp';
import { dateformat } from '../date-range';
import useErrorHandling from '../errorCheck';

type UserPageParams = {
  eqid: string;
  id: string;
};

/**
 * 機器部品一覧画面
 */
const PartsList: React.FunctionComponent = () => {
  const history = useHistory();
  const [pageInfo, setPageInfo] = useRecoilState(partsListPageInfo);
  const authContext = useContext(AuthenticatedContext); // ログインユーザの情報を取得
  const classes = useStyles();
  const [loading, setLoading] = useState(true); // ロード画面の状態管理
  const { eqid, id } = useParams<UserPageParams>();
  const [backFlg, setBackFlg] = useRecoilState(backPageFlg);
  const [data, setData] = useState<Parts[]>([]); // 表示するメインデータ
  const [subdata, setSubData] = useState<OneEquipment>();
  const [subdata2, setSubData2] = useState<DeviceDetail>();
  const containerRef = React.useRef<HTMLDivElement>(null);
  const [scroll, setScroll] = useState<number>(0); // テーブルのスクロール位置
  const [scrollHorizon, setScrollHorizon] = useState<number>(0); // テーブルのスクロール位置
  const { errorCheck } = useErrorHandling(); // エラー処理

  const setPageTitle = useSetRecoilState(pageTitle);
  React.useEffect(() => {
    return setPageTitle({ pageTitle: '機器部品一覧' }); // ページのタイトルを設定
  }, [setPageTitle]);

  // APIのURL
  const urlPartsList = history.createHref({ pathname: pathnames.partslist }); // 部品一覧取得URL
  const urlCountParts = history.createHref({
    pathname: pathnames.countparts,
  }); // 部品件数取得URL
  const urlOneEquipment = history.createHref({
    pathname: pathnames.oneEquipment,
  }); // 設備情報取得URL
  const urlDeviceDetail = history.createHref({
    pathname: pathnames.deviceDetail,
  }); // 機器情報取得URL
  // ページング用の変数
  const [totalData, setTotalData] = useState<number>(0); // データ数
  const [currentPage, setCurrentPage] = useState<number>(1); // 現在のページ
  const perPage = 20; // 一覧一ページあたりの表示件数

  // ソート用の変数
  type SortConfigType = { key: string; direction: string };
  const [sortConfig, setSortConfig] = React.useState<SortConfigType>({
    key: '',
    direction: '',
  });

  const headerCellProps = [
    {
      width: headerWidth.partsId,
      sortKey: 'partsId',
      text: '部品ID',
      className: `${classes.header} ${classes.stickyHeaderFirst}`,
    },
    {
      width: headerWidth.partsName,
      sortKey: 'partsName',
      text: '品名',
      className: `${classes.header} ${classes.stickyHeaderSecond}`,
    },
    {
      width: headerWidth.partsNo,
      sortKey: 'partsNo',
      text: '品番',
      className: `${classes.header} ${classes.stickyHeaderOther}`,
    },
    {
      width: headerWidth.qty,
      sortKey: 'qty',
      text: '数量',
      className: `${classes.header} ${classes.stickyHeaderOther}`,
      sortKey2: 'unit',
      text2: '単位',
    },
    {
      width: headerWidth.partsClass,
      sortKey: 'partsClass',
      text: '属性',
      className: `${classes.header} ${classes.stickyHeaderOther}`,
    },
    {
      width: headerWidth.repYear,
      sortKey: 'repYear',
      text: '交換周期',
      className: `${classes.header} ${classes.stickyHeaderOther}`,
    },
    {
      width: headerWidth.type,
      sortKey: 'type',
      text: '型式',
      className: `${classes.header} ${classes.stickyHeaderOther}`,
    },
    {
      width: headerWidth.partsMakerName,
      sortKey: 'makerName',
      text: '製造者',
      className: `${classes.header} ${classes.stickyHeaderOther}`,
    },
    {
      width: headerWidth.mainteType,
      sortKey: 'mainteType',
      text: '保全種別',
      className: `${classes.header} ${classes.stickyHeaderOther}`,
    },
    {
      width: headerWidth.insItem,
      sortKey: 'insItem',
      text: '点検項目',
      className: `${classes.header} ${classes.stickyHeaderOther}`,
    },
    {
      width: headerWidth.partsUse,
      sortKey: 'partsUse',
      text: '用途',
      className: `${classes.header} ${classes.stickyHeaderOther}`,
    },
    {
      width: headerWidth.biko,
      sortKey: 'biko',
      text: '備考',
      className: `${classes.header} ${classes.stickyHeaderOther}`,
    },
    {
      width: headerWidth.changeDate,
      sortKey: 'changeDate',
      text: '交換日',
      className: `${classes.header} ${classes.stickyHeaderOther}`,
    },
  ];

  // 画面遷移で送られた情報を設定する
  const locationSet = () => {
    // 初期値のままの場合
    if (currentPage === 0) {
      setCurrentPage(1);
    }
    // 戻るでの状態再現のフラグがTrueの場合
    if (backFlg.partsList) {
      setSortConfig({
        key: pageInfo.sortKey,
        direction: pageInfo.sortDirection,
      });
      setCurrentPage(pageInfo.page);
      // 一覧のテーブルがあるか確認
      if (containerRef.current) {
        setScroll(pageInfo.scrollPosition);
        setScrollHorizon(pageInfo.scrollPositionHorizon);
      }
      setBackFlg({ ...backFlg, partsList: false });
    }
  };

  // 一覧のページ変更処理
  const pageChange = (num: number) => {
    setScroll(0);
    setCurrentPage((prevPage) => {
      let newPage = prevPage + num;
      const tempTotalPages = Math.ceil(totalData / perPage);
      const totalPages = tempTotalPages > 0 ? tempTotalPages : 1;

      if (newPage < 1) newPage = 1;
      if (newPage > totalPages) newPage = totalPages;

      return newPage;
    });
  };

  // ソート機能の関数
  const sortStart = (key: string) => {
    pageChange(1 - currentPage); // はじめのページに戻る
    setScroll(0); // 表のスクロールバーをリセット
    let direction = 'asc';
    if (
      sortConfig &&
      sortConfig.key === key &&
      sortConfig.direction === 'asc'
    ) {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };

  // ページ遷移時の処理
  const movePage = (route: string) => {
    const tempScroll = containerRef.current
      ? containerRef.current.scrollTop
      : 0;
    const tempScrollHorizon = containerRef.current
      ? containerRef.current.scrollLeft
      : 0;
    setPageInfo({
      page: currentPage,
      scrollPosition: tempScroll,
      scrollPositionHorizon: tempScrollHorizon,
      sortKey: sortConfig.key,
      sortDirection: sortConfig.direction,
    });
    history.push(route);
  };

  // 初回画面表示時の処理
  useEffect(() => {
    setLoading(true); // 非同期処理前にsetLoading(true)
    locationSet();
    Promise.all([
      requestOneEquipment(urlOneEquipment, {
        equipmentId: Number(eqid),
      }),
      requestDeviceDetail(urlDeviceDetail, {
        custEqId: Number(eqid),
        mstId: Number(id),
      }),
    ])
      .then((responses) => {
        setSubData(responses[0].data); // 設備情報
        setSubData2(responses[1].data); // 機器情報
      })
      .catch((error) => {
        errorCheck(error); // エラー内容を確認
      })
      .finally(() => {
        setLoading(false); // 非同期処理後にsetLoading(false)
      });
  }, []);

  // データ更新時の処理
  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollTop = scroll;
      // 戻るのときのみ処理をする
      if (scrollHorizon !== 0) {
        containerRef.current.scrollLeft = scrollHorizon;
        setScrollHorizon(0);
      }
    }
  }, [data]);

  // 部品情報の取得
  useEffect(() => {
    setLoading(true); // 非同期処理前にsetLoading(true)
    Promise.all([
      requestCountParts(urlCountParts, {
        eqId: Number(eqid),
        mstId: Number(id),
      }),
      requestPartsList(urlPartsList, {
        eqId: Number(eqid),
        mstId: Number(id),
        number: perPage,
        page: currentPage,
        sortKey: sortConfig.key,
        sortDirection: sortConfig.direction,
      }),
    ])
      .then((responses) => {
        setTotalData(responses[0].data); // 件数
        setData(responses[1].data); // 設備情報
      })
      .catch((error) => {
        errorCheck(error); // エラー内容を確認
      })
      .finally(() => {
        setLoading(false); // 非同期処理後にsetLoading(false)
      });
  }, [currentPage, sortConfig]);

  return (
    <LoadingOverlay
      active={loading}
      className={classes.load}
      spinner
      text="データを読み込んでいます..."
    >
      <div className={classes.root}>
        <Button
          variant="primary"
          className="my-2"
          onClick={() => {
            setBackFlg({ ...backFlg, deviceList: true });
            history.push(`${routeName.deviceList}/${eqid}`);
          }}
        >
          戻る
        </Button>
        <br />
        <DataDisp userdata={authContext} data={subdata} data2={subdata2} />
        <div className={`${classes.paging} ${classes.partsListWidth}`}>
          <Paging
            totalData={totalData}
            currentPage={currentPage}
            perPage={perPage}
            onPageChange={pageChange}
          />
        </div>
        <TableContainer
          component={Paper}
          className={`${classes.tableContainer} ${classes.partsListHeight}`}
          ref={containerRef}
        >
          <Table stickyHeader className={classes.tableParts}>
            <TableHead>
              <TableRow>
                {/* ヘッダのセルを生成 */}
                {headerCellProps.map(
                  ({ width, sortKey, text, sortKey2, text2, className }) => (
                    <TableCell width={width} className={className}>
                      <Button
                        variant="link"
                        onClick={() => sortStart(sortKey)}
                        className={classes.linkButton}
                      >
                        {text}
                        {sortConfig &&
                          sortConfig.key === sortKey &&
                          (sortConfig.direction === 'asc' ? '▲' : '▼')}
                      </Button>
                      {/* ソートが2つある場合（数量単位用） */}
                      {sortKey2 != null && text2 != null && (
                        <Button
                          variant="link"
                          onClick={() => sortStart(sortKey2)}
                          className={classes.linkButton}
                        >
                          {text2}
                          {sortConfig &&
                            sortConfig.key === sortKey2 &&
                            (sortConfig.direction === 'asc' ? '▲' : '▼')}
                        </Button>
                      )}
                    </TableCell>
                  ),
                )}
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((d, index) => (
                <TableRow
                  key={d.mstId}
                  className={index % 2 === 0 ? classes.evenRow : classes.oddRow}
                >
                  <TableCell
                    className={`${classes.cellFix} ${classes.stickyColumnFirst} ${classes.numRow}`}
                  >
                    <Button
                      variant="link"
                      onClick={() =>
                        movePage(
                          `${routeName.partsDetail}/${eqid}/${id}/${
                            d.partsId ?? ''
                          }`,
                        )
                      }
                    >
                      {d.partsId}
                    </Button>
                  </TableCell>
                  <TableCell
                    className={`${classes.cellFix} ${classes.stickyColumnSecond} ${classes.stringRow}`}
                  >
                    {d.partsName}
                  </TableCell>
                  <TableCell
                    className={`${classes.cell} ${classes.stickyColumnOther} ${classes.stringRow}`}
                  >
                    {d.partsNo}
                  </TableCell>
                  <TableCell
                    className={`${classes.cell} ${classes.stickyColumnOther} ${classes.stringRow}`}
                  >
                    {d.qty} {d.unit}
                  </TableCell>
                  <TableCell
                    className={`${classes.cell} ${classes.stickyColumnOther} ${classes.stringRow}`}
                  >
                    {d.partsClass}
                  </TableCell>
                  <TableCell
                    className={`${classes.cell} ${classes.stickyColumnOther} ${classes.stringRow}`}
                  >
                    {d.repYear != null ? `${d.repYear}年` : ''}
                  </TableCell>
                  <TableCell
                    className={`${classes.cell} ${classes.stickyColumnOther} ${classes.stringRow}`}
                  >
                    {d.type}
                  </TableCell>
                  <TableCell
                    className={`${classes.cell} ${classes.stickyColumnOther} ${classes.stringRow}`}
                  >
                    {d.makerName}
                  </TableCell>
                  <TableCell
                    className={`${classes.cell} ${classes.stickyColumnOther} ${classes.stringRow}`}
                  >
                    {d.mainteType}
                  </TableCell>
                  <TableCell
                    className={`${classes.cell} ${classes.stickyColumnOther} ${classes.stringRow}`}
                  >
                    {d.insItem}
                  </TableCell>
                  <TableCell
                    className={`${classes.cell} ${classes.stickyColumnOther} ${classes.stringRow}`}
                  >
                    {d.partsUse}
                  </TableCell>
                  <TableCell
                    className={`${classes.cell} ${classes.stickyColumnOther} ${classes.stringRow}`}
                  >
                    {d.biko}
                  </TableCell>
                  <TableCell
                    className={`${classes.cell} ${classes.stickyColumnOther} ${classes.stringRow}`}
                  >
                    {dateformat(d?.changeDate)}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </LoadingOverlay>
  );
};

export default PartsList;
